import { render, staticRenderFns } from "./CardRealtime.vue?vue&type=template&id=c98b87d4"
import script from "./CardRealtime.vue?vue&type=script&lang=js"
export * from "./CardRealtime.vue?vue&type=script&lang=js"
import style0 from "./CardRealtime.vue?vue&type=style&index=0&id=c98b87d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports